import { ADMIN_KEYS, ADMIN_LOCALES, DEFAULT_ADMIN_LOCALE, } from './admin-keys.js';
import { adminEl } from './dictionaries/admin-el.js';
import { adminEn } from './dictionaries/admin-en.js';
export { ADMIN_KEYS, ADMIN_LOCALES, DEFAULT_ADMIN_LOCALE, } from './admin-keys.js';
export const adminDictionaries = {
    el: adminEl,
    en: adminEn,
};
export function isAdminLocale(value) {
    return value === 'el' || value === 'en';
}
export function tAdmin(locale, key, params) {
    const template = adminDictionaries[locale]?.[key] ?? adminDictionaries[DEFAULT_ADMIN_LOCALE][key] ?? key;
    if (!params)
        return template;
    return template.replace(/\{(\w+)\}/g, (_m, name) => String(params[name] ?? `{${name}}`));
}
export function findMissingAdminKeys(input = adminDictionaries) {
    const reports = [];
    const known = new Set(ADMIN_KEYS);
    for (const locale of ADMIN_LOCALES) {
        const dict = input[locale] ?? {};
        const missing = ADMIN_KEYS.filter((key) => !(key in dict));
        const empty = ADMIN_KEYS.filter((key) => key in dict && dict[key]?.trim() === '');
        const unknown = Object.keys(dict).filter((key) => !known.has(key));
        if (missing.length > 0 || empty.length > 0 || unknown.length > 0) {
            reports.push({ locale, missing, empty, unknown });
        }
    }
    return reports;
}
//# sourceMappingURL=admin.js.map